import { IMaintenanceBlankSchema } from '../../../maintenance.types.ts'
import { useRecoilValue } from 'recoil'
import maintenanceBlankSchemasAtom from '../../maintenanceBlankSchemas.atom.ts'
import { useMemo } from 'react'
import { IOption } from '@/types/global.ts'
import DropdownInput from '../../../../../../shared/Inputs/DropdownInput'

interface IProps {
  selectedBlankId: IMaintenanceBlankSchema['id']
  name: string
  onChange: (val: IMaintenanceBlankSchema['id'], name: string) => void
}

const MaintenanceBlankDropdown = (props: IProps) => {
  const blanks = useRecoilValue(maintenanceBlankSchemasAtom).items
  const blankOptions: IOption<IMaintenanceBlankSchema['id']>[] = useMemo(() => {
    return blanks.map((b) => ({ title: b.name, value: b.id }))
  }, [blanks])

  return (
    <DropdownInput
      options={blankOptions as any}
      selectedOption={props.selectedBlankId as any}
      title="Выберите из списка"
      onSelect={props.onChange}
      name={props.name}
    />
  )
}

export default MaintenanceBlankDropdown
